<div fxLayout class="sbnb-onboarding" style="margin-bottom: 24px; align-items: center; justify-content: center">
  <mat-spinner fxLayout fxLayoutAlign="center" [diameter]="30"></mat-spinner>
</div>
